import PhoneNumberLink from './PhoneNumberLink';

export default PhoneNumberLink;
